import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { CreateSubjectDialogComponent } from './create-subject-dialog.component';
import { GlobalModule } from '../../../../../global/global.module';
import { SelectListV2Module } from '../../../../../global/components/forms/select-list-v2/select-list-v2.module';

@NgModule({
    declarations: [CreateSubjectDialogComponent],
    imports: [CommonModule, ReactiveFormsModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule, TranslateModule, GlobalModule, SelectListV2Module],
    exports: [CreateSubjectDialogComponent],
})
export class CreateSubjectDialogModule {}
